export const onlyNumbers = (text: string) => {
  return `${text}`.replace(/\D/g, '');
};
